/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable solid/prefer-for */
/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** @jsxImportSource solid-js */
import type { Component, JSX } from 'solid-js';
import { createSignal, createEffect, createMemo, For, untrack } from 'solid-js';
import DatePicker, {
  type PickerInputJSXProps,
  type PickerRenderJSXProps,
} from '@rnwonder/solid-date-picker';
import '@rnwonder/solid-date-picker/dist/style.css';
import { noShadowDOM } from 'solid-element';

// Custom input component for DatePicker renderInput
const DatePickerInput: Component<any> = (props) => {
  const hasError = (): boolean => Boolean(false); // We'll handle error state from parent
  const inputClass = (): string | undefined =>
    hasError() ? 'error' : undefined;

  // Prevent any manual input/typing
  const handleKeyDown: JSX.EventHandlerUnion<
    HTMLInputElement,
    KeyboardEvent
  > = (event) => {
    // Prevent all keyboard input
    event.preventDefault();
  };

  const handleInput: JSX.EventHandlerUnion<HTMLInputElement, InputEvent> = (
    event
  ) => {
    // Prevent any input changes
    event.preventDefault();
  };

  const handlePaste: JSX.EventHandlerUnion<HTMLInputElement, ClipboardEvent> = (
    event
  ) => {
    // Prevent paste
    event.preventDefault();
  };

  const handleClick: JSX.EventHandlerUnion<HTMLDivElement, MouseEvent> = (
    event
  ) => {
    event.preventDefault();
    // Ensure showDate is available and call it
    if (props.showDate) {
      props.showDate();
    }
  };

  return (
    <div
      class="input-focus-group"
      style={{ position: 'relative' }}
      onClick={handleClick}
    >
      <input
        type="text"
        class={inputClass()}
        value={props.value().label}
        placeholder={props.placeholder || 'Select a date'}
        disabled={props.disabled}
        readonly={props.readonly}
        onClick={handleClick}
        onKeyDown={handleKeyDown} // Prevent typing
        onInput={handleInput} // Prevent input changes
        onPaste={handlePaste} // Prevent paste
        style={{ cursor: 'pointer', 'padding-right': '2rem' }} // Add padding for icon
      />
      <div class="line" />
      {/* Date picker icon */}
      <div
        style={{
          position: 'absolute',
          right: '0.5rem',
          top: '50%',
          transform: 'translateY(-50%)',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        <i class="icon-font tc-icon-calendar text-gray-500 i16" />
      </div>
    </div>
  );
};

// Custom calendar top area with month and year selectors
const CustomCalendarTopArea: Component<PickerRenderJSXProps> = (props) => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const handlePrevMonth = (): void => {
    const currentMonth = props.month();
    const currentYear = props.year();

    if (currentMonth === 0) {
      props.setMonth(11);
      props.setYear(currentYear - 1);
    } else {
      props.setMonth(currentMonth - 1);
    }
  };

  const handleNextMonth = (): void => {
    const currentMonth = props.month();
    const currentYear = props.year();

    if (currentMonth === 11) {
      props.setMonth(0);
      props.setYear(currentYear + 1);
    } else {
      props.setMonth(currentMonth + 1);
    }
  };

  const handleMonthChange = (event: Event): void => {
    const target = event.target as HTMLSelectElement;
    props.setMonth(parseInt(target.value, 10));
  };

  const handleYearChange = (event: Event): void => {
    const target = event.target as HTMLSelectElement;
    props.setYear(parseInt(target.value, 10));
  };

  // Generate year options (current year ± 10 years)
  const YEARS_RANGE = 21;
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from(
    { length: YEARS_RANGE },
    (_, i) => currentYear - 10 + i
  );

  return (
    <div
      class="pb-0 py-1 px-2"
      style={{
        'background-color': '#005f9e',
        padding: '12px',
        'border-radius': '4px 4px 0px 0px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'space-between',
      }}
    >
      {/* Previous Month Button */}
      <button
        type="button"
        onClick={handlePrevMonth}
        style={{
          background: 'none',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          padding: '4px 8px',
          'border-radius': '0',
          'font-size': '16px',
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)')
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.backgroundColor = 'transparent')
        }
      >
        <i class="icon-font tc-icon-chevron-left text-white" />
      </button>

      {/* Month and Year Selectors */}
      <div style={{ display: 'flex', 'align-items': 'center', gap: '16px' }}>
        <div style={{ position: 'relative' }}>
          <select
            value={props.month()}
            onChange={handleMonthChange}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              padding: '4px 20px 4px 8px',
              width: 'auto',
              'font-size': '16px',
              appearance: 'none',
              '-webkit-appearance': 'none',
              '-moz-appearance': 'none',
            }}
          >
            {/* TODO: Refactor to use <For> */}
            {monthNames.map((month, index) => (
              <option style={{ color: '#000' }} value={index}>
                {month.substring(0, 3)}
              </option>
            ))}
          </select>
          <div
            style={{
              position: 'absolute',
              right: '0px',
              top: '43%',
              transform: 'translateY(-50%)',
              'pointer-events': 'none',
            }}
          >
            <i class="icon-font tc-icon-arrow-drop-down text-white" />
          </div>
        </div>

        <div style={{ position: 'relative' }}>
          <select
            value={props.year()}
            onChange={handleYearChange}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              padding: '4px 20px 4px 8px',
              width: 'auto',
              'font-size': '16px',
              appearance: 'none',
              '-webkit-appearance': 'none',
              '-moz-appearance': 'none',
            }}
          >
            <For each={yearOptions}>
              {(year) => (
                <option style={{ color: '#000' }} value={year}>
                  {year}
                </option>
              )}
            </For>
          </select>
          <div
            style={{
              position: 'absolute',
              right: '0px',
              top: '43%',
              transform: 'translateY(-50%)',
              'pointer-events': 'none',
            }}
          >
            <i class="icon-font tc-icon-arrow-drop-down text-white" />
          </div>
        </div>
      </div>

      {/* Next Month Button */}
      <button
        type="button"
        onClick={handleNextMonth}
        style={{
          background: 'none',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          padding: '4px 8px',
          'border-radius': '0',
          'font-size': '16px',
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)')
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.backgroundColor = 'transparent')
        }
      >
        <i class="icon-font tc-icon-chevron-right text-white" />
      </button>
    </div>
  );
};

export interface CustomDatePickerProps {
  name: string;
  label: string;
  setFocus?: boolean;

  // Common input attributes
  id?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  readonly?: boolean;
  required?: boolean;
  'data-cy'?: string;
  dataCy?: string;

  // Validation-like props
  error?: string;
  touched?: boolean;

  // Event callbacks
  onInput?(
    event: InputEvent & { currentTarget: HTMLInputElement; target: Element }
  ): void;
  onChange?(
    event: Event & { currentTarget: HTMLInputElement; target: Element }
  ): void;
  onBlur?(
    event: FocusEvent & { currentTarget: HTMLInputElement; target: Element }
  ): void;
  onFocus?(
    event: FocusEvent & { currentTarget: HTMLInputElement; target: Element }
  ): void;
}

const CustomDatePicker: Component<CustomDatePickerProps> = (props) => {
  noShadowDOM();
  const v = untrack(() => props.value);

  // Root element reference for event dispatching
  let rootRef: HTMLDivElement | undefined;

  // Helper function to parse ISO date string without timezone conversion
  const parseISODate = (dateString: string): Date | undefined => {
    const isoDateMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (isoDateMatch) {
      const year = parseInt(isoDateMatch[1], 10);
      const month = parseInt(isoDateMatch[2], 10) - 1; // 0-indexed for Date constructor
      const day = parseInt(isoDateMatch[3], 10);

      const date = new Date(year, month, day);
      return !isNaN(date.getTime()) ? date : undefined;
    }

    // Fallback for other formats
    const date = new Date(dateString);
    return !isNaN(date.getTime()) ? date : undefined;
  };

  const [selectedDate, setSelectedDate] = createSignal<Date | undefined>(
    v ? parseISODate(v) : undefined
  );

  // Format date as "Nov 13, 2025"
  const formatDateForDisplay = (date: Date | undefined): string => {
    if (!date || isNaN(date.getTime())) {
      return '';
    }
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    };
    return date.toLocaleDateString('en-US', options);
  };

  // Create a reactive memo for the display value
  const displayValue = createMemo(() => formatDateForDisplay(selectedDate()));

  // Sync external value changes
  createEffect(() => {
    const value = props.value;
    if (value && value.trim()) {
      try {
        const parsedDate = parseISODate(value);
        const currentDate = selectedDate();

        // Only update if date actually changed
        if (!currentDate || parsedDate?.getTime() !== currentDate.getTime()) {
          setSelectedDate(parsedDate);
        }
      } catch (error) {
        console.error('Invalid date value:', value, error);
        setSelectedDate(undefined);
      }
    } else {
      if (selectedDate() !== undefined) {
        setSelectedDate(undefined);
      }
    }
  });

  const getId = (): string | undefined => props.id ?? props.name;
  const getDataCy = (): string | undefined =>
    props.dataCy ?? props['data-cy'] ?? props.name;
  const hasError = (): boolean => Boolean(props.touched && props.error);

  const handleDateChange = (data: any) => {
    if (data.type === 'single' && data.selectedDate) {
      let date: Date;
      let dateString: string;

      // Check if selectedDate is a plain object with year/month/day properties
      if (
        data.selectedDate &&
        typeof data.selectedDate === 'object' &&
        'year' in data.selectedDate &&
        'month' in data.selectedDate &&
        'day' in data.selectedDate
      ) {
        // Use picker values directly to avoid timezone conversion issues
        // Note: picker uses 0-indexed months (0-11), so we add 1 for ISO format (1-12)
        const year = data.selectedDate.year;
        const month = String(data.selectedDate.month + 1).padStart(2, '0');
        const day = String(data.selectedDate.day).padStart(2, '0');
        dateString = `${year}-${month}-${day}`;

        // Convert the plain object to a Date object for internal state
        // Note: picker uses 0-indexed months (0-11), same as JavaScript Date
        date = new Date(
          data.selectedDate.year,
          data.selectedDate.month,
          data.selectedDate.day
        );
      } else if (data.selectedDate instanceof Date) {
        date = data.selectedDate;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        dateString = `${year}-${month}-${day}`;
      } else {
        console.error('Invalid date format:', data.selectedDate);
        return;
      }

      // Verify it's a valid Date
      if (isNaN(date.getTime())) {
        console.error('Invalid date selected:', date);
        return;
      }

      setSelectedDate(date);

      // Dispatch custom event directly on the root element
      if (rootRef) {
        const customEvent = new CustomEvent('tc-customdatepicker-input', {
          detail: { value: dateString },
          bubbles: true,
        });
        rootRef.dispatchEvent(customEvent);
      }

      // Call the onInput prop if provided
      const syntheticEvent = new Event('input', { bubbles: true });
      props.onInput?.(
        syntheticEvent as unknown as InputEvent & {
          currentTarget: HTMLInputElement;
          target: Element;
        }
      );
    }
  };

  // Custom renderInput function for DatePicker
  const renderCustomInput = (inputProps: PickerInputJSXProps): JSX.Element => {
    // Create a new value function that overrides the library's value
    // Using the reactive displayValue memo ensures updates when selectedDate changes
    const customInputProps = {
      ...inputProps,
      value: () => ({
        label: displayValue(), // Use the reactive memo
        value: selectedDate(),
      }),
    };

    return <DatePickerInput {...customInputProps} />;
  };

  return (
    <div class="input-group" ref={rootRef}>
      <style>
        {`
          .date-picker-wrapper {
            padding: 0px !important;
          }
          .date-picker-calendar-wrapper {
            padding: 24px !important;
            background: #ffffff !important;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
            border-radius: 8px !important;
          }
          .date-picker-body-area {
            padding: 0px !important;
          }
          .date-picker-days-btn {
            font-weight: 300 !important;
          }
          .date-picker-position-fix {
            z-index: 1000 !important;
            position: fixed !important;
          }
          [data-solid-date-picker-portal] {
            z-index: 1000 !important;
            position: relative !important;
          }
        `}
      </style>
      <label for={getId()}>
        <span>{props.label}</span>
      </label>
      <div class="relative">
        <DatePicker
          weekDaysType="double"
          pickerPositionX="center"
          pickerPositionY="top"
          shouldCloseOnSelect={true}
          onChange={handleDateChange}
          type="single"
          renderInput={renderCustomInput}
          calendarTopAreaJSX={CustomCalendarTopArea}
          datePickerWrapperClass="date-picker-wrapper"
          calendarWrapperClass="date-picker-calendar-wrapper"
          calendarOneAreaClass="date-picker-body-area"
          daysBtnClass="date-picker-days-btn"
          zIndex={1000}
          primaryColor="#005f9e"
          primaryTextColor="#ffffff"
          secondaryColor="#dbeafe"
          backgroundColor="#ffffff"
          textColor="#374151"
          weekDaysNameColor="#000000"
        />
      </div>
      {hasError() && <div class="error-message">{props.error}</div>}

      {/* Hidden input for form compatibility */}
      <input
        type="hidden"
        id={getId()}
        name={props.name}
        value={
          selectedDate() &&
          selectedDate() instanceof Date &&
          !isNaN(selectedDate()!.getTime())
            ? selectedDate()!.toISOString().split('T')[0]
            : ''
        }
        data-cy={getDataCy()}
      />
    </div>
  );
};

export default CustomDatePicker;
